<template>
  <div class="animated fadeIn">
    <b-tabs
      active-nav-item-class="font-weight-bold text-uppercase text-danger">
      <b-tab title="관리자 정보">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              관리자 정보
            </div>
            <div class="mb7">
              <span class="pull-right" v-if="!add && model.created_at">가입일  : {{model.created_at | datetime}}</span>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_use" v-b-tooltip.hover title="Allow login.">
                로그인 허용
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" checked="" v-model="model.is_alive" :disabled="lock" />
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_group" v-b-tooltip.hover title="Permission.">
                권한
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <v-select v-if="!lock" label="text" v-model="model.permissions" :options="codes.permissions_admin"></v-select>
              <b-form-input type="text" v-if="lock" :value="model.permissions" plaintext></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.id">
              <label class="col-form-label" for="">
                마지막 접속일
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-10 col-md-12 d-flex align-self-center">
              {{model.last_visit | datetime}} @ {{model.last_addr}}
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_username" v-b-tooltip.hover title="Username">
                사용자명(ID)
                <span class="text-danger ml-1">*</span>
                <span v-if="model.is_del" class="text-danger">삭제된 사용자입니다. 허용하더라도 로그인이 불가능합니다.</span>
              </label>
            </b-col>
            <b-col class="col-xl-10 col-md-12 d-flex align-self-center">
              <b-form-input class="form-control" :disabled="!add || lock" type="text" id="ph_username" v-model="model.username" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <!-- {{model}} -->
          <!-- <password :badge="true" v-model="model.new_password" :strengthMeterOnly="false" :toggle="false" @score="showScore" @feedback="showFeedback" /> -->
          <b-row class="mb-2" v-show="add || !lock">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_pass">
                {{add ? '사용자' : '새'}} 비밀번호
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-form-input class="form-control" type="password" id="ph_pass" v-model="model.new_password" :plaintext="lock"></b-form-input>
              <b-badge v-if="model.new_password"  :variant="password_policy('number') ? 'success' : 'danger'"> 숫자 </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> 대문자 </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> 소문자 </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> 특수문자 </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('length') ? 'success' : 'danger'">
                최소 글자 : 10글자
              </b-badge>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.new_password">
              <label class="col-form-label" for="ph_pass2">
                비밀번호 확인
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12"  v-if="model.new_password">
              <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_nickname">
                이름
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-10 col-md-12">
              <b-form-input class="form-control" type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_group" v-b-tooltip.hover title="단일 IP 또는 네트워크 범위를 입력하세요, etc) 192.168.0.100, 192.168.0.0/24 ">
                허용된 IP
              </label>
            </b-col>
            <b-col class="col-xl-10 col-md-12">
              <b-form-textarea class="form-control" ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :plaintext="lock"></b-form-textarea>
            </b-col>
          </b-row>
          <br>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title_sub">
              지역
            </div>
          </div>
          <hr>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_country_group" v-b-tooltip.hover title="country">국가<span class="text-danger ml-1">*</span></label>
                <v-select :readonly="true" :disabled="lock" label="name" v-model="region.country" :options="codes.country" ></v-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_language_group" v-b-tooltip.hover title="language">언어<span class="text-danger ml-1">*</span></label>
                <v-select :readonly="true" :disabled="lock" label="name" v-model="region.language" :options="codes.language"></v-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_timezone_group" v-b-tooltip.hover title="Timezone">시간대<span class="text-danger ml-1">*</span></label>
                <v-select :readonly="true" :disabled="lock" label="name" v-model="region.timezone" :options="codes.timezone" ></v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab title="관리자 로그인 로그" :disabled="!model.id" @click="() => this.$refs._login_list && this.$refs._login_list.refresh()">
        <log-Login-List v-if="model.id" :user="model" ref="_login_list"></log-Login-List>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>